export default {
    "The online prints tool is loading. Please wait": "La herramienta de impresión en línea se está cargando. Espera, por favor",
    "Add photos": "Añadir fotos",
    "Options": "Opciones",
    "Extras": "Extras",
    "Upload your photos": "Subir tus fotos",
    "Get started! Upload some photos": "¡Vamos allá! Subir algunas fotos",
    "We’re analyzing your photos for the next step. Analyzing photos %s of %s": "Se están examinando tus fotos para el siguiente paso. Examinando fotos %s de %s",
    "%s You’ve already uploaded this photo.": "%s Ya has subido esta foto.",
    "We couldn’t read the image ‘%s’ so it will not be included in your image collection. This might happen if the file is not an image file (for example a jpeg or png), or because the image is broken. Please check the file and try to re-upload it": "No se ha podido leer la imagen ‘%s’, por lo que no se incluirá en tu colección de imágenes. Esto puede pasar si el archivo no es un archivo de imagen (por ejemplo un jpeg o png), o porque la imagen está defectuosa. Comprueba el archivo y vuelve a subirlo.",
    "We couldn’t upload the image ‘%s’ because you tried to upload a file type the editor doesn’t support. Supported types are ‘%s’.": "No se ha podido subir la imagen ‘%s’ porque has intentado subir un tipo de archivo no compatible con el editor. Los tipos compatibles son ‘%s’.",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum file size is %s.": "No se ha podido subir la imagen ‘%s’ porque la imagen es demasiado grande. El tamaño máximo de archivo es %s.",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum allowed dimensions are %s x %s pixels.": "No se ha podido subir la imagen ‘%s’ porque la imagen es demasiado grande. Las dimensiones máximas admitidas son %s x %s píxeles.",
    "Could not upload ‘%s’ because of error: %s. See console for more info.": "No se ha podido cargar ‘%s’ debido a un error: %s. Consulta el panel para obtener más información.",
    "Upload more photos": "Subir más fotos",
    "Your photos are uploading: %s of %s complete": "Tus fotos se están cargando: %s de %s completado",
    "Photos added: ‘%s’ to your collection": "Fotos añadidas: ‘%s’ a tu colección",
    "%s of %s uploaded": "Subido %s de %s",
    "Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us.": "No se puede mostrar la foto. Prueba a borrarla y subirla de nuevo. Si sigue sin poder mostrarse, ponte en contacto con nosotros.",
    "Your photo collection": "Tu colección de fotos",
    "Tap here to change photo format, add a filter or change quantity, for all photos in this order": "Pulsa aquí para cambiar el formato de la foto, añadir un filtro o cambiar la cantidad, para todas las fotos de este pedido",
    "Swipe to reveal more options": "Deslizar para ver más opciones",
    "We will make you aware if images are low resolution and notify you when cropping will occur.": "Recibirás un aviso si las imágenes tienen una baja resolución y si se van a recortar.",
    "Edit your photos":  "Editar fotos",
    "You’re ordering %s photos": "Tu pedido incluye %s fotos",
    "Low resolution images": "Imágenes de baja resolución",
    "You’ve uploaded one or more images at low resolution. These images might see loss in quality in print.": "Has subido una o varias imágenes de baja resolución. Estas imágenes pueden perder calidad en la impresión.",
    "For better results, choose a smaller print size. Low resolution images have been marked with the icon displayed above.": "Para obtener un mejor resultado, elije un tamaño de impresión más pequeño. Las imágenes de baja resolución se han marcado con el icono que aparece arriba.",
    "One or more photos have been cropped to fit the selected print size.": "Se han recortado una o varias fotos para ajustarlas al tamaño de impresión seleccionado.",
    "Cropped photos have been marked with the icon displayed above. We recommend that you check your cropped photos before ordering.": "Las fotos recortadas se han marcado con el icono que aparece arriba. Comprueba las fotos recortadas antes de realizar el pedido.",
    "Cannot show photo. Please try deleting and uploading it again. If it still doesn’t show, please contact us.": "No se puede mostrar la foto. Bórrala y súbela de nuevo. Si sigue sin poder mostrarse, ponte en contacto con nosotros.",
    "Duplicate photo": "Duplicado",
    "Cropped photos":  "Fotos recortadas",
    "Info": "Información",
    "More info": "Más información",
    "Total": "Total",
    "Price per print": "Precio por impresión",
    "Finish your order": "Finalizar pedido",
    "Save and finish later": "Guardar y finalizar más tarde",
    "Got it!": "¡Entendido!",
    "Low resolution image": "Imágenes de baja resolución",
    "Photo cropped": "Foto recortada",
    "Standard sizes": "Tamaños convencionales",
    "Enlargements": "Ampliación de fotos",
    "Edit": "Editar",
    "Save": "Guardar",
    "Reset": "Reiniciar",
    "Original": "Original",
    "Sephia": "Sepia",
    "B/W": "B/N",
    "Black and white": "Blanco y negro",
    "Edit all": "Editar todo",
    "Done": "Hecho",
    "Select filter": "Seleccionar filtro",
    "Close": "Cerrar",
    "Add filter": "Añadir filtro",
    "List of available filters...": "Lista de filtros disponibles...",
    "Select format": "Seleccionar formato",
    "Choose size": "Elegir tamaño",
    "Size:": "Tamaño:",
    "Editing multiple photos will be available when all the photos are analyzed": "No se pueden editar varias fotos cuando se están examinando todas las fotos",
    "Amount": "Cantidad",
    "Prints": "Copias",
    "Cannot show photo. Please try deleting and uploading it again and, if it still doesn’t show, please contact us for assistance.": "No se puede mostrar la foto. Bórrala y súbela de nuevo y, si sigue sin aparecer, ponte en contacto con nosotros para obtener ayuda.",
    "Do more with your photos": "Sácale más partido a tus fotos",
    "Order your prints": "Encarga tus copias",
    "Enlarge": "Ampliar",
    "%s photos": "%s fotos",
    "Adding cart items. Two more steps...": "Añadir artículos a la cesta. Dos pasos más...",
    "We’re processing your order. One more step…": "Tu pedido se está procesando Un paso más...",
    "Redirecting to cart. Just a moment...": "Redirigiendo a la cesta. Un momento...",
    "Paper": "Papel",
    "Other": "Otros",
    "Are you sure you want to delete this product from your shopping basket?": "¿Estás seguro de que quieres quitar este producto de la cesta?",
    "Something went wrong when adding items to cart. See details below.": "Se produjo un error al añadir los artículos a la cesta. Consulta los detalles más abajo.",
    "Image enhancement will automatically optimise your images, bringing out the colour in every photo. We recommend disabling this option if you’ve already enhanced your photos with other software or apps, such as Instagram.": "El servicio de mejora de imágenes optimizará automáticamente las imágenes, resaltando el color de cada foto. Te recomendamos que desactives esta opción si ya has mejorado tus fotos con otros programas o aplicaciones, como Instagram.",
    "You're ordering 1 print.": "Vas a encargar 1 copia.",
    "Your device has lost internet connection": "",
    "Delete?": "",
    "Yes": "",
    "No": "",
    "The maximum allowed number of photos is %s but you can add multiple orders to one cart and buy all your photos at once. To order more, add this order to your cart then return to the editor.": "El número máximo de fotos permitido es %s, pero puedes añadir varios pedidos a la cesta y comprar todas tus fotos a la vez. Para encargar más, añade este pedido a la cesta y luego vuelve al editor.",
    "For you to order, we need to finish uploading your photos": "",
    "%s premium prints": "",
    "Retro": "",
    "We’re sorry: we couldn’t registrer file %s, so we’ve removed it from your order. This might be a temporary error and you could try uploading it again": "",
    "Customer service": "Atención al cliente",
    "Privacy": "Privacidad",
    "Disclaimer": "Términos y condiciones",
    "Use photos from minnebanken": "Usar fotos de minnebanken",
    "Please log in with": "",
    "Memory bank": "",
    "%s photos selected": "",
    "Timeline": "",
    "Events": "",
    "Collections": "",
    "Import photos": "",
    "Choose collection": "",
    "Choose event": "",
    "Unable to get photos": "",
    "No photos": "",
    "More photos...": "",
    "Unable to get timeline data": "",
    "Unable to get events data": "",
    "Unable to get collections data": "",
    "No timelines": "",
    "No events": "",
    "No collections": "",
    "January": "",
    "February": "",
    "March": "",
    "April": "",
    "May": "",
    "June": "",
    "July": "",
    "August": "",
    "September": "",
    "October": "",
    "November": "",
    "December": "",
    "All months": "",
    "All days": "",
    "Click here to add polaroid text": "Puedes introducir tu texto aquí",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser, order fewer photos at a time or first upload to Photo Organiser.": "No se puede cambiar el tamaño de la foto. Esto suele pasar cuando el navegador está sobrecargado procesando muchas fotos grandes. Puedes probar con otro navegador, encargar menos fotos de una vez o subirlas primero a Photo Organiser.",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser or order fewer photos at a time.":"No se puede cambiar el tamaño de la foto. Esto suele pasar cuando el navegador está sobrecargado procesando muchas fotos grandes. Puedes probar con otro navegador o encargar menos fotos de una vez.",
    "Could not load photos from Photo Organiser because there are no photos in the basket.": "No se han podido cargar fotos desde Photo Organiser porque no hay fotos en la cesta.",
    "Please know that if you leave the page now, your changes will be lost": "",
    "Quantity:": "",
    "Loading photos from minnebanken...": "Subir fotos de minnebanken...",
    "Select all": "",
    "Select nothing": "",
    "Check your photos": "Comprobar la calidad de las fotos",
    "Loading...": "",
    "Loading, please wait": "¡Un momento! Ya casi hemos terminado.",
    "%s images have a low-resolution warning. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s imágenes con un aviso de baja resolución. Comprueba las fotos marcadas con una señal de advertencia. Si decides no hacerlo, no se puede garantizar la máxima calidad de tus copias.",
    "%s photos have been cropped and not validated. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s fotos se han recortado y no se han validado. Comprueba las fotos marcadas con una señal de advertencia. Si decides no hacerlo, no se puede garantizar la máxima calidad de tus copias.",
    "Some photos need attention": "Tienes que revisar algunas fotos",
    "Continue": "Continuar",
    "Check photos": "Comprobar las fotos",
    "Check your cropped photos": "Comprobar las fotos recortadas",
    "Check your low resolution images": "Revisa tus imágenes de baja resolución",
    "Unable to load images from temporary selection API in Photo Organise": "",
    "Unfortunately your browser does not support all options for creating this product. Please install Safari, Chrome, Firefox or a newer version of Internet Explorer (11 or Edge) and start again.": ""
 };
 
